import React, {ReactElement} from "react"
import CheckPayments, {CheckPaymentsColumns} from "../../components/CheckPayments/CheckPayments"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import {useIsBankUser, useIsUnitUser} from "../../services/auth"

export default function CheckPaymentsPage(): ReactElement {
	const isBankOrUnit = useIsBankUser() || useIsUnitUser()

	return (
		<>
			<TitleBar title={"Check Payments"} />
			<MainSectionTable>
				<CheckPayments
					enableAmountFilter={true}
					enableOrgFilter={true}
					enableAdditionalVerificationFilter={true}
					enableDateFilter={true}
					fullHeight={true}
					enableStatusFilter={true}
					enablePurposeFilter={true}
					disableDrawer={false}
					includedColumns={[
						CheckPaymentsColumns.id,
						...(isBankOrUnit ? [CheckPaymentsColumns.org] : []),
						CheckPaymentsColumns.accountId,
						CheckPaymentsColumns.customer,
						CheckPaymentsColumns.amount,
						CheckPaymentsColumns.status,
						...(!isBankOrUnit ? [CheckPaymentsColumns.isAccountClosureCheck] : []),
						CheckPaymentsColumns.additionalVerification,
						CheckPaymentsColumns.createdAt,
						CheckPaymentsColumns.sendAt,
					]}
				/>
			</MainSectionTable>
		</>
	)
}
